import type { EnrollmentConversionDetail } from "./enrollmentTypes";
import {
  ComplianceTable,
  ErrorState,
  FailuresToConvertTable,
  LoadingState,
  MissingObjectionReasonsTable,
  SectionDivider,
} from "./enrollmentUi";

export function EnrollmentCallReviewsTab(props: {
  end: string;
  error: string;
  loading: boolean;
  rows: EnrollmentConversionDetail[];
  setEnd: (date: string) => void;
  setStart: (date: string) => void;
  start: string;
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          Start
          <input
            aria-label="Call review start date"
            type="date"
            value={props.start}
            max={props.end}
            onChange={(event) => props.setStart(event.target.value)}
            className="mt-1 block rounded-md border border-border bg-background px-2.5 py-1.5 text-sm text-foreground"
          />
        </label>
        <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          End
          <input
            aria-label="Call review end date"
            type="date"
            value={props.end}
            min={props.start}
            onChange={(event) => props.setEnd(event.target.value)}
            className="mt-1 block rounded-md border border-border bg-background px-2.5 py-1.5 text-sm text-foreground"
          />
        </label>
        <div className="mb-1.5 text-xs text-muted-foreground">
          Dates use Eastern Time. Default range is yesterday.
        </div>
      </div>

      <SectionDivider label="Failures to convert" />
      {props.loading ? (
        <LoadingState />
      ) : props.error ? (
        <ErrorState message={props.error} />
      ) : (
        <FailuresToConvertTable rows={props.rows} />
      )}

      <SectionDivider label="Missing objection reasons" />
      {props.loading ? (
        <LoadingState />
      ) : props.error ? (
        <ErrorState message={props.error} />
      ) : (
        <MissingObjectionReasonsTable rows={props.rows} />
      )}

      <SectionDivider label="Compliance" />
      {props.loading ? (
        <LoadingState />
      ) : props.error ? (
        <ErrorState message={props.error} />
      ) : (
        <ComplianceTable rows={props.rows} />
      )}
    </div>
  );
}
